import * as moment from 'moment';
import 'moment-timezone';

import { DropdownItem } from '@gosuite/selects';
import { RangeDates } from '@gosuite/range-datepicker';

import { Occupancy } from '../../../searchform/multi-room-dialog/multi-room-utils';
import { AdvancedSearchformModel } from '../../../searchform/advanced-search-dialog/shared/advanced-searchform.model';


export class SearchformNhModel {
	public destinationAirports: Array<DropdownItem>;
	public destinationRegions: Array<DropdownItem>;
	public destinationCities: Array<DropdownItem>;
	public hotels: Array<DropdownItem>;
	public dates: RangeDates;
	public minDuration: number;
	public maxDuration: number;
	public adultsNumber: number;
	public childAge1: number;
	public childAge2: number;
	public childAge3: number;
	public childAge4: number;
	public category: number;
	public rating: number;
	public boardTypes: Array<DropdownItem>;
	public roomTypes: Array<DropdownItem>;
	public maxPrice: number;
	public tourOperators: Array<DropdownItem>;
	public negateTourOperatorsSelect: boolean;
	public seaView: boolean;
	public hygiene: boolean;
	public topsFlops: Array<DropdownItem>;
	public occupancy?: Occupancy|null;
	public geoJson?: string|null;
	public advancedSearchformData?: AdvancedSearchformModel|null;
}

export const InitialSearchformNhState: SearchformNhModel = {
	destinationAirports: [],
	destinationRegions: [],
	destinationCities: [],
	hotels: [],
	dates: new RangeDates(moment().tz('Europe/Berlin').add(14, 'days').toDate(), moment().tz('Europe/Berlin').add(28, 'days').toDate()),
	minDuration: 6,
	maxDuration: 8,
	adultsNumber: 2,
	childAge1: null,
	childAge2: null,
	childAge3: null,
	childAge4: null,
	category: null,
	rating: null,
	boardTypes: [],
	roomTypes: [],
	maxPrice: null,
	tourOperators: [],
	negateTourOperatorsSelect: false,
	seaView: false,
	hygiene: false,
	topsFlops: [],
	occupancy: null,
	geoJson: null,
	advancedSearchformData: null
};



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/models/searchform/searchform-nh.model.ts